import CardSystem, { getCardHandler } from '../CardSystem';
import { ICardStateTaskData } from '../../../State/Card/ICardState';
import AnimationTask from '../../../Utility/Task/AnimationTask';
import CardComponent from '../../../Component/Level/Card';

export default function UndoFlipCardAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData
): void {
    for (const cardID of taskData.cards) {
        const card = system.getCardByID(cardID);
        getCardHandler(card).setCardFaceUp(true);
        system.taskQueue.queue(
            new AnimationTask(
                'CardFlip',
                card,
                {
                    faceUp: false,
                    rotation: card.getComponent(CardComponent).rotation,
                    scale: 1,
                },
                true
            )
        );
    }
}
